export default __webpack_public_path__ + "static/media/cat16.f145b726.png";